/**
 * Locale-independent content: assets, contact details and the structural
 * metadata (icons, flags) that pairs with the translated copy in data/copy.
 */

export type HighlightIcon =
  | 'scissors'
  | 'blowout'
  | 'color'
  | 'treatment'
  | 'extensions'
  | 'event'

/** Same order as `highlights.items` in each locale file. */
export const highlightMeta: { id: string; icon: HighlightIcon }[] = [
  { id: 'corte', icon: 'scissors' },
  { id: 'blowout', icon: 'blowout' },
  { id: 'color', icon: 'color' },
  { id: 'tratamientos', icon: 'treatment' },
  { id: 'extensiones', icon: 'extensions' },
  { id: 'eventos', icon: 'event' },
]

/** Same order as `schedule.days` in each locale file. */
export const scheduleMeta: { featured?: boolean; closed?: boolean }[] = [
  {},
  {},
  {},
  {},
  { featured: true },
  { featured: true },
  { closed: true },
]

export type ContactItem = {
  id: string
  icon: 'phone' | 'mobile' | 'pin' | 'instagram' | 'mail'
  value: string
  href?: string
}

export const salon = {
  phone: '(718) 273-3434',
  phoneHref: 'tel:+17182733434',
  whatsappDisplay: '(347) 853-1793',
  whatsappNumber: '13478531793',
  addressShort: '2031 Forest Avenue',
  addressFull: '2031 Forest Avenue, Staten Island, NY 10303',
  mapsHref: 'https://maps.google.com/?q=2031+Forest+Avenue+Staten+Island+NY+10303',
  instagramHandle: '@lareina_beauty_salon_llc',
  instagramHref: 'https://instagram.com/lareina_beauty_salon_llc',
  instagramAlt: 'Lareinabeautysalon',
  tiktokHref: 'https://www.tiktok.com/@lareinabeautysalon1',
  email: 'lareinabeautysalon1@gmail.com',
  emailHref: 'mailto:lareinabeautysalon1@gmail.com',
  rating: '4.7+',
}

/** Builds a WhatsApp deep link with a prefilled message in the active language. */
export function whatsappHref(message: string): string {
  return `https://wa.me/${salon.whatsappNumber}?text=${encodeURIComponent(message)}`
}

export const contactItems: ContactItem[] = [
  { id: 'tel', icon: 'phone', value: salon.phone, href: salon.phoneHref },
  { id: 'cel', icon: 'mobile', value: salon.whatsappDisplay },
  { id: 'dir', icon: 'pin', value: salon.addressFull, href: salon.mapsHref },
  { id: 'ig', icon: 'instagram', value: salon.instagramHandle, href: salon.instagramHref },
  { id: 'ig2', icon: 'instagram', value: salon.instagramAlt },
  { id: 'mail', icon: 'mail', value: salon.email, href: salon.emailHref },
]

/** Effective date of the privacy policy and terms of service (ISO). */
export const legalUpdated = '2026-09-06'

export const assets = {
  banner: 'https://cdn.magicpatterns.com/uploads/tjg1P1rNcTJUp7t798vWds/BANNER_LA_REINA.png',
  logo: 'https://cdn.magicpatterns.com/uploads/wsW8vTGWRQQdAGuQxLakY3/LOGO_LA_REINA.png',
}
